export default __webpack_public_path__ + "static/media/Outfit-Regular.8422587f.ttf";